export const AddToCartIconDiscount = ({width = 32, height = 32}: {width: number; height: number}) => {
  return (
    <svg width={width} height={height} viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="1" y="1" width="34" height="34" rx="17" fill="white" stroke="white" strokeWidth="2" />
      <rect x="1.5" y="1.5" width="33" height="33" rx="16.5" fill="white" stroke="#F22643" />
      <path d="M17 19V25H19V19H25V17H19V11H17V17H11V19H17Z" fill="#F22643" />
    </svg>
  );
};
